import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/profiles/list.js